import { FC, useEffect, useState } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';
import { DDComponent } from '@telialt/utils/src/datadog/setup';
import { useLogError } from '@telialt/utils/src/datadog/useLogError';

import { getAgreementId } from '../../constants';
import { useB2BAgreementsQuery } from '../../hooks/useB2BAgreementsQuery';
import { MobileMenuItemComponentB2b } from './MobileMenuItemComponentB2b';
import { MobileMenuItemComponentSkeleton } from './MobileMenuItemComponentSkeleton';

type Props = {
    item: NavigationItem;
    menuLevel: number;
};

export const MobileMenuItemComponentMandates: FC<Props> = ({ item, menuLevel }) => {
    const [isMounted, setIsMounted] = useState(false);

    const { data: agreements, isLoading: isAgreementsLoading, error } = useB2BAgreementsQuery();
    useLogError(error, DDComponent.Navbar);

    const agreementId = isMounted ? getAgreementId() : undefined;
    const isCompanyOwner = agreements?.find((agreement) => agreement.agreementId === agreementId)?.type === 'COMPANY';

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted || isAgreementsLoading) {
        return <MobileMenuItemComponentSkeleton />;
    }

    if (!isCompanyOwner) {
        return null;
    }

    return <MobileMenuItemComponentB2b item={item} menuLevel={menuLevel} />;
};
